export const LinkTestIdFactory = {
    // Bases - can be used externally for regex matching in getByTestId
    // to select multiple components regardless of their passed test id
    getLinkBase: () => 'link',
    // for test id generation
    getLinkTestId: (testId) => [LinkTestIdFactory.getLinkBase(), testId].join('-'),
};
